import { loadable } from 'nordic/lazy';
import ReviewsCapability from '.';
import Reviews from './reviews';

const ReviewsMobileCapability = loadable(() => import('./reviews-capability'));

export default Reviews(props => ReviewsCapability(props, ReviewsMobileCapability, true));
